import { PagingInfoModel } from "../query/paging-info-model";
import { TemplateDocumentType } from "./document-template-model";

export class TemplateSearchModel extends PagingInfoModel {
    documentTypes?: TemplateDocumentType[];
    name?: string;
    categoryId?: string;
    templateId?: string;
    searchTerm!: string;
    priceLowValue?: number = 0;
    priceHighValue?: number;
}
